import { Paragraph } from 'roo-ui/components';

const RequestReviewInfo = () => (
  <Paragraph fontSize="lg">
    Please double check your request details are correct. After submitting the request, we’ll get in touch with you within 24 hours to
    confirm your changes.
  </Paragraph>
);

export default RequestReviewInfo;
